'use client';

import a__default, { createContext } from "react";
const defaultContextValue = (props) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content -- should be handled by Chalk components implemented with this quark
  /* @__PURE__ */ a__default.createElement("a", { ...props })
);
const CustomAnchorContext = createContext(defaultContextValue);
const CustomAnchorProvider = CustomAnchorContext.Provider;
export {
  CustomAnchorContext,
  CustomAnchorProvider
};
